export default __webpack_public_path__ + "static/media/budget-tracker.10a54efd.png";